//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  af: "Afganisztán",
  ax: "Åland-szigetek",
  al: "Albánia",
  dz: "Algéria",
  as: "Amerikai Szamoa",
  vi: "Amerikai Virgin-szigetek",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarktisz",
  ag: "Antigua és Barbuda",
  ar: "Argentína",
  aw: "Aruba",
  au: "Ausztrália",
  at: "Ausztria",
  um: "Az USA lakatlan külbirtokai",
  az: "Azerbajdzsán",
  bs: "Bahama-szigetek",
  bh: "Bahrein",
  bd: "Banglades",
  bb: "Barbados",
  by: "Belarusz",
  be: "Belgium",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermuda",
  bt: "Bhután",
  gw: "Bissau-Guinea",
  bo: "Bolívia",
  ba: "Bosznia-Hercegovina",
  bw: "Botswana",
  bv: "Bouvet-sziget",
  br: "Brazília",
  io: "Brit Indiai-óceáni Terület",
  vg: "Brit Virgin-szigetek",
  bn: "Brunei",
  bg: "Bulgária",
  bf: "Burkina Faso",
  bi: "Burundi",
  cl: "Chile",
  cy: "Ciprus",
  km: "Comore-szigetek",
  ck: "Cook-szigetek",
  cr: "Costa Rica",
  cw: "Curaçao",
  td: "Csád",
  cz: "Csehország",
  dk: "Dánia",
  za: "Dél-afrikai Köztársaság",
  kr: "Dél-Korea",
  ss: "Dél-Szudán",
  gs: "Déli-Georgia és Déli-Sandwich-szigetek",
  dm: "Dominika",
  do: "Dominikai Köztársaság",
  dj: "Dzsibuti",
  ec: "Ecuador",
  gq: "Egyenlítői-Guinea",
  us: "Egyesült Államok",
  ae: "Egyesült Arab Emírségek",
  gb: "Egyesült Királyság",
  eg: "Egyiptom",
  ci: "Elefántcsontpart",
  er: "Eritrea",
  kp: "Észak-Korea",
  mk: "Észak-Macedónia",
  mp: "Északi Mariana-szigetek",
  ee: "Észtország",
  et: "Etiópia",
  fk: "Falkland-szigetek",
  fo: "Feröer szigetek",
  fj: "Fidzsi",
  fi: "Finnország",
  tf: "Francia Déli Területek",
  gf: "Francia Guyana",
  pf: "Francia Polinézia",
  fr: "Franciaország",
  ph: "Fülöp-szigetek",
  ga: "Gabon",
  gm: "Gambia",
  gh: "Ghána",
  gi: "Gibraltár",
  gr: "Görögország",
  gd: "Grenada",
  gl: "Grönland",
  ge: "Grúzia",
  gp: "Guadeloupe",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gn: "Guinea",
  gy: "Guyana",
  ht: "Haiti",
  hm: "Heard-sziget és McDonald-szigetek",
  bq: "Holland Karib-térség",
  nl: "Hollandia",
  hn: "Honduras",
  hk: "Hongkong KKT",
  hr: "Horvátország",
  in: "India",
  id: "Indonézia",
  iq: "Irak",
  ir: "Irán",
  ie: "Írország",
  is: "Izland",
  il: "Izrael",
  jm: "Jamaica",
  jp: "Japán",
  ye: "Jemen",
  je: "Jersey",
  jo: "Jordánia",
  ky: "Kajmán-szigetek",
  kh: "Kambodzsa",
  cm: "Kamerun",
  ca: "Kanada",
  cx: "Karácsony-sziget",
  qa: "Katar",
  kz: "Kazahsztán",
  tl: "Kelet-Timor",
  ke: "Kenya",
  cn: "Kína",
  kg: "Kirgizisztán",
  ki: "Kiribati",
  cc: "Kókusz (Keeling)-szigetek",
  co: "Kolumbia",
  cg: "Kongó - Brazzaville",
  cd: "Kongó - Kinshasa",
  cf: "Közép-afrikai Köztársaság",
  cu: "Kuba",
  kw: "Kuvait",
  la: "Laosz",
  pl: "Lengyelország",
  ls: "Lesotho",
  lv: "Lettország",
  lb: "Libanon",
  lr: "Libéria",
  ly: "Líbia",
  li: "Liechtenstein",
  lt: "Litvánia",
  lu: "Luxemburg",
  mg: "Madagaszkár",
  hu: "Magyarország",
  mo: "Makaó KKT",
  my: "Malajzia",
  mw: "Malawi",
  mv: "Maldív-szigetek",
  ml: "Mali",
  mt: "Málta",
  im: "Man-sziget",
  ma: "Marokkó",
  mh: "Marshall-szigetek",
  mq: "Martinique",
  mr: "Mauritánia",
  mu: "Mauritius",
  yt: "Mayotte",
  mx: "Mexikó",
  mm: "Mianmar",
  fm: "Mikronézia",
  md: "Moldova",
  mc: "Monaco",
  mn: "Mongólia",
  me: "Montenegró",
  ms: "Montserrat",
  mz: "Mozambik",
  na: "Namíbia",
  nr: "Nauru",
  de: "Németország",
  np: "Nepál",
  ni: "Nicaragua",
  ne: "Niger",
  ng: "Nigéria",
  nu: "Niue",
  nf: "Norfolk-sziget",
  no: "Norvégia",
  eh: "Nyugat-Szahara",
  it: "Olaszország",
  om: "Omán",
  ru: "Oroszország",
  am: "Örményország",
  pk: "Pakisztán",
  pw: "Palau",
  ps: "Palesztin Terület",
  pa: "Panama",
  pg: "Pápua Új-Guinea",
  py: "Paraguay",
  pe: "Peru",
  pn: "Pitcairn-szigetek",
  pt: "Portugália",
  pr: "Puerto Rico",
  re: "Réunion",
  ro: "Románia",
  rw: "Ruanda",
  kn: "Saint Kitts és Nevis",
  lc: "Saint Lucia",
  mf: "Saint Martin",
  vc: "Saint Vincent és a Grenadine-szigetek",
  bl: "Saint-Barthélemy",
  pm: "Saint-Pierre és Miquelon",
  sb: "Salamon-szigetek",
  sv: "Salvador",
  sm: "San Marino",
  st: "São Tomé és Príncipe",
  sc: "Seychelle-szigetek",
  sl: "Sierra Leone",
  sx: "Sint Maarten",
  es: "Spanyolország",
  lk: "Srí Lanka",
  sr: "Suriname",
  ch: "Svájc",
  sj: "Svalbard és Jan Mayen",
  se: "Svédország",
  ws: "Szamoa",
  sa: "Szaúd-Arábia",
  sn: "Szenegál",
  sh: "Szent Ilona",
  rs: "Szerbia",
  sg: "Szingapúr",
  sy: "Szíria",
  sk: "Szlovákia",
  si: "Szlovénia",
  so: "Szomália",
  sd: "Szudán",
  sz: "Szváziföld",
  tj: "Tádzsikisztán",
  tw: "Tajvan",
  tz: "Tanzánia",
  th: "Thaiföld",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tr: "Törökország",
  tt: "Trinidad és Tobago",
  tn: "Tunézia",
  tc: "Turks- és Caicos-szigetek",
  tv: "Tuvalu",
  tm: "Türkmenisztán",
  ug: "Uganda",
  nc: "Új-Kaledónia",
  nz: "Új-Zéland",
  ua: "Ukrajna",
  uy: "Uruguay",
  uz: "Üzbegisztán",
  vu: "Vanuatu",
  va: "Vatikán",
  ve: "Venezuela",
  vn: "Vietnám",
  wf: "Wallis és Futuna",
  zm: "Zambia",
  zw: "Zimbabwe",
  cv: "Zöld-foki Köztársaság",
};
